export default "__VITE_ASSET__63440a46__"